<template>
  <div>
    <template>
      <template v-if="value.eventType === eventTypes.departure">
        <flight-info-departure :value="value.flight" />
      </template>
      <template v-if="value.eventType === eventTypes.arrival">
        <flight-info-arrival :value="value.flight" />
      </template>
      <v-divider />
      <flight-info-ac :value="value.flight" />
      <v-divider />
      <div class="title">Connections</div>
      <progress-bar :isLoading="this.connectionsIsLoading" />
      <template
        v-if="!this.connectionsIsLoading && (!connections || !connections.length)"
      >
        <v-subheader>No connections to show</v-subheader>
      </template>
      <template
        v-else
        v-for="item in connections"
      >
        <flight-connection-item
          :value="item"
          :key="item.id"
          :eventType="findConnectionEventType"
          :now="now"
        />
        <v-divider :key="'d' + item.id" />
      </template>
    </template>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import ProgressBar from '@/components/ProgressBar'
  import FlightConnectionItem from '@/components/FlightConnectionItem'
  import FlightInfoArrival from '@/components/FlightInfoArrival'
  import FlightInfoDeparture from '@/components/FlightInfoDeparture'
  import FlightInfoAc from '@/components/FlightInfoAc'
  import { eventTypes } from '../config/eventTypes'

  export default {
    props: {
      value: {
        type: Object,
        required: true
      }
    },
    created() {
      this.fetchFlightData(this.value.flight.id)
    },
    components: {
      ProgressBar,
      FlightInfoAc,
      FlightConnectionItem,
      FlightInfoArrival,
      FlightInfoDeparture
    },
    methods: {
      fetchFlightData: function (flightId) {
        this.$store.dispatch('flightConnections/fetchFlightBean', flightId)
      }
    },
    computed: {
      connections() {
        switch (this.value.eventType) {
          case 'ARRIVAL':
            return this.connectionsTo
          case 'DEPARTURE':
            return this.connectionsFrom
          default:
            console.log('No event type set for flight:', this.flightBean)
            return {}
        }
      },
      ...mapState({
        now: (state) => state.app.now
      }),
      ...mapGetters({
        flightBean: 'flightConnections/flightBean',
        connectionsIsLoading: 'flightConnections/isLoading',
        connectionsTo: 'flightConnections/connectionsTo',
        connectionsFrom: 'flightConnections/connectionsFrom'
      }),
      eventTypes() {
        return eventTypes
      },
      findConnectionEventType() {
        return this.value.eventType === eventTypes.arrival ? 'DEPARTURE' : 'ARRIVAL'
      }
    }
  }
</script>
